import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

const DEFAULT_COMMIT = 'production';

export const FCM_CONTACT_DECISION_MAKER = defineFcm('contact_decision_maker')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				// optional so a gate-only row (`{"enabled": true}`) normalizes instead of falling back to the default
				promptId: { type: 'string', optional: true },
				commit: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault({
		enabled: false,
		promptId: '',
		commit: DEFAULT_COMMIT,
	})
	.withMerger(({ localeValue, countryValue, globalValue }) => ({
		enabled: localeValue.enabled && countryValue.enabled,
		promptId: localeValue.promptId || countryValue.promptId || globalValue.promptId || '',
		commit: localeValue.commit || countryValue.commit || globalValue.commit || DEFAULT_COMMIT,
	}))
	.toConfig({
		owner: 'squad-vaquita',
		scope: ['corgi-middle-end'],
		context: 'Supporter → DM Outreach',
		description:
			'Rollout gate and LangSmith prompt pointer for the Supporter → DM Outreach draft step. US + English only for the MVP pilot: set `enabled: true` on BOTH the en-US locale row and the US country row — either one alone leaves the feature off. Set `promptId` (and optionally `commit`, which defaults to "production") on the global row to re-point the prompt without a redeploy; a locale or country row overrides it.',
		mergeLogic:
			'`enabled` is true only when both the locale row and the country row are true — the global row cannot enable it. `promptId` and `commit` take the first non-empty of locale, country, then global, falling back to "" and "production".',
		// template values must stay falsy apart from the gate: the merger prefers any non-empty scoped
		// value, so a pre-filled commit on a locale/country row would shadow the global one for good
		template: {
			enabled: false,
			promptId: '',
			commit: '',
		},
	});
